import React from "react";

const ContentToPrint = React.forwardRef((props, ref) => {
  const { children, footer, header, sign, rootClassName = "" } = props;

  return (
    <div
      ref={ref ?? null}
      className={`print-container prescription-print-root ${rootClassName}`.trim()}
      style={{ backgroundColor: "#fff" }}
    >
      <table className="prescription-print-layout">
        <thead>
          <tr>
            <td className="prescription-print-thead-cell">
              <div className="prescription-print-doc-header">
                {header ?? null}
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {children}
          {/* {sign ? (
            <tr className="prescription-print-sign-last-row">
              <td className="prescription-print-tbody-cell prescription-print-sign-last">
                <div className="prescription-print-sign-inner">{sign}</div>
              </td>
            </tr>
          ) : null} */}
        </tbody>
        <tfoot>
          <tr>
            <td className="prescription-print-footer-guard" />
          </tr>
        </tfoot>
      </table>
      {footer ? (
        <div className="prescription-print-doc-footer prescription-print-footer-pin">
          {footer}
        </div>
      ) : null}
    </div>
  );
});

// ContentToPrint.displayName = "ContentToPrint";

export default ContentToPrint;
